/// <amd-module name="Build/Run/Constants" />
export namespace Telemetry {
  export const Area = "Build";

  export const RunArtifacts = "Pipelines.RunArtifacts";
  export const RunDetails = "Pipelines.RunDetails";
  export const RunLogs = "Pipelines.RunLogs";
}

/**
 * Use this for linking
 * This name is just for URL and the contribution loaded will still be unified-test-results-tab
 *  this is required to maintain compat and ensure there are no breaking links
 */
export const NavTestTabId = "ms.vss-test-web.build-test-results-tab";

// Tab id for LWP CodeCoverage CI tab in build
export const CodeCoverageCiTabId = "codecoverage-tab";

export const AuthorizationCheckTypeIdString: string = "E1A1FC6C-C278-4492-AE1C-C42F8697612C";
export const ManualValidationTaskTypeIdString: string = "2003AD3A-104A-451A-9238-60474AB294E6";
export const TaskCheckTypeIdString = "fe1de3ee-a436-41b4-bb20-f6eb4cb879a7";

//ID for checking Approval Timeout
export const ApprovalCheckTypeId: string = "8C6F20A7-A545-4486-9777-F762FAFE0D4D";

export const RetentionSettingDataContributionId = "ms.vss-build-web.pipelines-retention-data-provider";

export enum LeaseType {
  Pipeline = "Pipeline",
  Branch = "Branch",
  User = "User",
  ReleaseManagment = "RM",
}
